import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Document } from "@contentful/rich-text-types";

type ComponentFaq = {
  __typename: "ComponentFaq";
  itemsCollection: {
    items: ({ question?: string | null; answer?: { json: Document } | null } | null)[];
  };
};

const isComponentFaq = (component: any): component is ComponentFaq => {
  return component?.__typename === "ComponentFaq";
};

export const FaqStructuredData = ({
  components,
}: {
  components: ({ __typename: string } | ComponentFaq)[];
}) => {
  const faqItems = components
    .filter(isComponentFaq)
    .flatMap((component) => component?.itemsCollection?.items ?? []);

  if (faqItems.length === 0) {
    return null;
  }

  const qas = faqItems.flatMap((item) => {
    const a = item?.answer?.json;
    const q = item?.question;

    if (q && a) {
      return {
        "@type": "Question",
        name: q,
        acceptedAnswer: {
          "@type": "Answer",
          text: documentToHtmlString(a),
        },
      };
    }

    return [];
  });

  if (qas.length === 0) {
    return null;
  }

  const faqs = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: qas,
  });

  return faqs ? (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: faqs }}
    ></script>
  ) : null;
};
